import { ChangeEventHandler } from 'react';

import { Box, Button, Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';

export interface IExistingCibsCustomField {
    billingRecord: string;
    showDuplicates: (value: string) => void;
    saveDuplicatesOnChange: (value: boolean) => void;
    saveDuplicatesChecked: boolean;
    testId: string;
}

export function ExistingCibsCustomField (props: Readonly<IExistingCibsCustomField>) {
    const EXISTING_CIBS_WARNING = 'Save duplicate? A license with this CIBS exists';

    const handleCheckboxChange: ChangeEventHandler<HTMLInputElement> = event => {
        props.saveDuplicatesOnChange(event.target.checked);
    };

    return (
        <Box display="flex" alignItems="center" justifyContent="space-between">
            <FormGroup>
                <FormControlLabel
                    control={<Checkbox data-testid={props.testId} checked={props.saveDuplicatesChecked} onChange={handleCheckboxChange} />}
                    label={
                        <Typography variant="body2" gutterBottom component="div">
                            {EXISTING_CIBS_WARNING}
                        </Typography>
                    }
                />
            </FormGroup>
            <Button
                variant='contained'
                component='span'
                color='primary'
                sx={{ textTransform: 'none', mt: 2 }}
                onClick= {() => props.showDuplicates(props.billingRecord)}
            >
                View Duplicates
            </Button>
        </Box>
    );
}
